import React from "react";
export const NameColumnFormatter = (
  cellContent,
  row,
  rowIndex,
  {isEdit,setNameValue,nameValue}
) =>{

  if(isEdit===row.id)
  {
    return (
    <>
        <input
            type="text"
            className="form-control"
            name="name"
            value={nameValue}
            onChange={(e) => {
              setNameValue(e.target.value);
            }}
        />
    </>)
  }
  else
  {
    return  (
        <>
        {row.name}
        </>
    )
  }
}
